import {Location} from '@angular/common';
import {HttpClient, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import * as moment from 'moment';
import {of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {CreatorSection, defaultTags, ModelTag} from '../../models/CreatorModels';
import {AuthService} from '../../services/auth.service';
import {CommonService} from '../../services/common.service';
import {ConsentsFormService} from '../../services/consents-form.service';
import {FileService} from '../../services/file.service';
import {LocalStorageService} from '../../services/local-storage.service';
import {NotificationService} from '../../services/notification.service';
import {ToastMessagesService} from '../../services/toast-messages.service';

@Component({
    selector: 'app-custom-form-display',
    templateUrl: './custom-form-display.component.html',
    styleUrls: ['./custom-form-display.component.scss']
})
export class CustomFormDisplayComponent implements OnInit {
    child: any;
    childDisplayName: string;
    childSchool: string;
    code = '';
    edit: boolean;
    form: any;
    isLoading: boolean;
    mode: string;
    notificationId: number;
    parent: any;
    user: any;
    parentDisplayName: string;
    sectionTypes: any[];
    sections: any[] = [];
    showTwoFactor: boolean;
    showUploadField: boolean;
    uniqueId: string;
    isFieldDisabled: boolean;
    isExternal: boolean;
    isChecked: boolean;
    defaultMemberTags: ModelTag[] = defaultTags;
    editorStylePreview: any;
    update: boolean;
    files: any[] = [];
    filesPath: any;
    currentFiles: any[] = [];
    validLink: boolean;
    submitMessage: string;

    constructor(public route: ActivatedRoute,
                private commonService: CommonService,
                public router: Router,
                private httpClient: HttpClient,
                public location: Location,
                private authService: AuthService,
                private fileService: FileService,
                private localStorageService: LocalStorageService,
                private notificationService: NotificationService,
                public toastMessagesService: ToastMessagesService,
                private consentFormService: ConsentsFormService) {
        this.user = JSON.parse(this.localStorageService.get('user'));
        this.isLoading = true;
        this.sectionTypes = this.commonService.sectionTypes;
        this.parentDisplayName = '';
        this.childDisplayName = '';
        this.childSchool = '';
        this.showTwoFactor = false;
        this.showUploadField = false;
        this.isFieldDisabled = false;
        this.editorStylePreview = {height: '100%;', border: '0px'};
        this.isChecked = false;
        this.validLink = true;
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(async (params) => {
            this.mode = params.mode;
            this.uniqueId = params.unique_id;
            this.edit = params.edit;
            this.isExternal = params.external ? params.external === 'true' : false;

            if (params.parentId) {
                await this.initializeParent(this.user.id);
            }
            if (params.update) {
                this.update = true;
            }

            if (params.childId) {
                // const validChild = this.parent.children.some(child => child.id === +params.childId);
                // if (validChild) {
                await this.initializeChild(+params.childId);
                // } else {
                //     this.validLink = false;
                //     return;
                // }
            }

            this.notificationId = +params.notificationId;


            if (params.edit === 'true' && params.mode === 'false') {

                await this.getCustomFormResultsByChildAndUniqueId(params.childId, params.unique_id);
                const form = await this.consentFormService.getCustomFormByUniqueId(this.uniqueId);
                this.submitMessage = form.submit_message;

            } else if (params.edit === 'false' && params.mode === 'true' && !this.update) {
                this.isFieldDisabled = true;
                await this.getCustomFormResultsByChildAndUniqueId(params.childId, params.unique_id, +params.id);
                const form = await this.consentFormService.getCustomFormByUniqueId(this.uniqueId);
                this.submitMessage = form.submit_message;

            } else if (params.edit === 'false' && params.mode === 'true' && this.update === true) {
                this.isFieldDisabled = false;
                await this.getCustomFormResultsByChildAndUniqueId(params.childId, params.unique_id, +params.id);
                const form = await this.consentFormService.getCustomFormByUniqueId(this.uniqueId);
                this.submitMessage = form.submit_message;
                this.isFieldDisabled = this.form.canParentEdit === 0;

            } else {
                if (this.isExternal) {
                    const shouldInitializeNewForm = await this.initializeCompletedForm(params.childId, params.unique_id);
                    if (shouldInitializeNewForm) {
                        await this.initializeForm(params.unique_id);
                        this.submitMessage = this.form.submit_message;
                    }
                    this.isLoading = false;
                } else {
                    await this.initializeForm(params.unique_id);
                    this.submitMessage = this.form.submit_message;
                }
            }
            this.showUploadField = this.form.hasUploadField ? this.form.hasUploadField : false;
            if (this.uniqueId && (this.child && this.child.id)) {
                await this.initializeUploadedFiles();
            }

            if (this.uniqueId && this.parent?.id) {
                await this.initializeUploadedFiles();
            }

            this.isChecked = this.form.isChecked && this.form.isChecked === 1 ? true : false;
        });
    }

    async initializeUploadedFiles() {
        try {
            const request = await this.commonService.getList(`files/upload-custom-form-files?uniqueId=${this.uniqueId}&childId=${this.child.id}`);
            this.currentFiles = request.object;
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    // initializeCompletedForm
    async initializeCompletedForm(childId, uniqueId) {
        try {
            this.form = await this.consentFormService.getCustomCompletedFormChildResults(childId, uniqueId);
            if (this.form) {
                // this.isFieldDisabled = this.form.canPareEdit === 1;
                const value = JSON.parse(this.form.value);
                this.sections = value.results;
                for (const section of this.sections) {
                    section.expanded = false;
                    section.title = section.title ? section.title.replace(/'/g, '\'\'') : '';
                    for (const member of section.members) {
                        member.title = member.title ? member.title.replace(/'/g, '\'\'') : '';
                        const type = this.sectionTypes.find(t => t.id === member.type.id);
                        if (type) {
                            member.type = type;
                        }
                    }
                }
                for (const section of value.results) {
                    for (const member of section.members) {
                        if (member.value) {
                            const val = member.options.find(option => option.id === member.value.id);
                            if (val) {
                                member.value = val;
                            }
                        }
                    }
                }
                // this.isFieldDisabled = true;
                return false;
            } else {
                return true;
            }
        } catch (e) {
            console.log(e);
            this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να αρχικοποιήσουμε την δήλωση');
            return true;
        }
    }

    getMemberPredefinedValue(tag: ModelTag) {
        try {
            if (tag.value === '[parent-displayName]') {
                return this.parentDisplayName ? this.parentDisplayName : '-';
            }
            //#region Child Info
            if (tag.value === '[child-first-name]') {
                return this.child.firstName ? this.child.firstName : '-';
            }
            if (tag.value === '[child-last-name]') {
                return this.child.lastName ? this.child.lastName : '-';
            }
            if (tag.value === '[child-displayName]') {
                return `${this.child.firstName} ${this.child.lastName}`;
            }
            if (tag.value === '[child-birthday]') {
                return `${moment(this.child.birthday).format('DD/MM/YYYY')}`;
            }
            if (tag.value === '[child-telephone]') {
                return this.child.phone ? this.child.phone : '-';
            }
            if (tag.value === '[child-email]') {
                return this.child.email ? this.child.email : '-';
            }
            //#endregion

            //#region Father Info
            if (tag.value === '[father-first-name]') {
                return this.child.father_first_name ? this.child.father_first_name : '-';
            }
            if (tag.value === '[father-last-name]') {
                return this.child.father_last_name ? this.child.father_first_name : '-';
            }
            if (tag.value === '[father-displayName]') {
                return this.child.father_first_name ? `${this.child.father_first_name} ${this.child.father_last_name}` : '-';
            }
            if (tag.value === '[father-telephone]') {
                return this.child.father_telephone ? this.child.father_telephone : '-';
            }
            if (tag.value === '[father-email]') {
                return this.child.father_email ? this.child.father_email : '-';
            }
            //#endregion

            //#region Mother Info
            if (tag.value === '[mother-first-name]') {
                return this.child.mother_first_name ? this.child.mother_first_name : '-';
            }
            if (tag.value === '[mother-last-name]') {
                return this.child.mother_last_name ? this.child.mother_last_name : '-';
            }
            if (tag.value === '[mother-displayName]') {
                return this.child.mother_first_name ? `${this.child.mother_first_name} ${this.child.mother_last_name}` : '-';
            }
            if (tag.value === '[mother-telephone]') {
                return this.child.mother_telephone ? this.child.mother_telephone : '-';
            }
            if (tag.value === '[mother-email]') {
                return this.child.mother_email ? this.child.mother_email : '-';
            }
            //#endregion
        } catch (e) {
            console.log(e);
        }
    }

    // initialize Parent's Info (or User's Info for Single User Model)
    async initializeParent(id: number) {
        try {
            const result = await this.commonService.getList(`people/parent?id=${id}`);
            if (result.object && result.object[0]) {
                this.parent = result.object[0];
                this.parent.displayName = `${this.parent.first_name} ${this.parent.last_name}`;
            } else {
                // Single User Model: use user data as parent
                this.parent = {
                    id: this.user.id,
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    displayName: `${this.user.first_name} ${this.user.last_name}`,
                    email: this.user.email,
                    telephone: this.user.telephone
                };
            }
        } catch (e) {
            // Fallback to user data on error (Single User Model)
            this.parent = {
                id: this.user.id,
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                displayName: `${this.user.first_name} ${this.user.last_name}`,
                email: this.user.email,
                telephone: this.user.telephone
            };
        }
    }

    // initialize Child's Info (or User's Info for Single User Model)
    async initializeChild(id: number) {
        try {
            const result = await this.commonService.getList(`students/id?id=${id}`);
            if (result.object && result.object[0]) {
                this.child = result.object[0];
                this.child.displayName = `${this.child.firstName} ${this.child.lastName}`;
            } else {
                // Single User Model: user is acting for themselves, not a child
                // Use user data as "child" for backward compatibility
                this.child = {
                    id: this.user.id,
                    firstName: this.user.first_name,
                    lastName: this.user.last_name,
                    displayName: `${this.user.first_name} ${this.user.last_name}`,
                    email: this.user.email,
                    phone: this.user.telephone,
                    birthday: null,
                    father_first_name: this.user.first_name,
                    father_last_name: this.user.last_name,
                    father_email: this.user.email,
                    father_telephone: this.user.telephone,
                    mother_first_name: this.user.first_name,
                    mother_last_name: this.user.last_name,
                    mother_email: this.user.email,
                    mother_telephone: this.user.telephone
                };
            }
        } catch (e) {
            // Fallback to user data on error (Single User Model)
            this.child = {
                id: this.user.id,
                firstName: this.user.first_name,
                lastName: this.user.last_name,
                displayName: `${this.user.first_name} ${this.user.last_name}`,
                email: this.user.email,
                phone: this.user.telephone,
                birthday: null,
                father_first_name: this.user.first_name,
                father_last_name: this.user.last_name,
                father_email: this.user.email,
                father_telephone: this.user.telephone,
                mother_first_name: this.user.first_name,
                mother_last_name: this.user.last_name,
                mother_email: this.user.email,
                mother_telephone: this.user.telephone
            };
        }
    }

    async getCustomFormResultsByChildAndUniqueId(childId, uniqueId, id?: number) {
        try {
            this.form = await this.consentFormService.getCustomFormChildResults(childId, uniqueId, id);
            // this.isFieldDisabled = this.form.canParentEdit === 1;
            // await this.initializeParent(this.form.parent_id);
            await this.initializeParent(this.user.id);
            const value = JSON.parse(this.form.value);
            this.sections = value.results;

            for (const section of this.sections) {
                section.expanded = false;
                section.title = section.title ? section.title.replace(/'/g, '\'\'') : '';
                for (const member of section.members) {
                    if (member.value) {
                        const val = member.options.find(option => option.id === member.value.id);
                        if (val) {
                            member.value = val;
                        }
                    }
                    if (member.type.type === 'label') {
                        if (member.value) {
                            member.value = this.getEditorMemberPredefinedValue(member.value);
                        }
                    }
                    if (member.tag) {
                        member.value = this.getMemberPredefinedValue(member.tag);
                    }
                    member.title = member.title ? member.title.replace(/'/g, '\'\'') : '';
                    const type = this.sectionTypes.find(t => t.id === member.type.id);
                    if (type) {
                        member.type = type;
                    }
                }
            }
        } catch (e) {
            console.log(e);
            this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να αρχικοποιήσουμε την δήλωση');
        } finally {
            this.isLoading = false;
        }
    }

    async initializeForm(uniqueId: string) {
        try {
            this.form = await this.consentFormService.getCustomFormByUniqueId(uniqueId);
            this.sections = JSON.parse(this.form.sections);

            for (const section of this.sections) {
                section.expanded = false;
                section.title = section.title ? section.title.replace(/'/g, '\'\'') : '';
                for (const member of section.members) {
                    if (member.type.type === 'label') {
                        if (member.value) {
                            member.value = this.getEditorMemberPredefinedValue(member.value);
                        }
                    }

                    if (member.type.type === 'toggle') {
                        member.value = false;
                    }

                    if (member.tag) {
                        member.value = this.getMemberPredefinedValue(member.tag);
                    }
                    member.title = member.title ? member.title.replace(/'/g, '\'\'') : '';
                    const type = this.sectionTypes.find(t => t.id === member.type.id);
                    if (type) {
                        member.type = type;
                    }
                }
            }

        } catch (e) {
            console.log(e);
            this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να αρχικοποιήσουμε την δήλωση');
        } finally {
            this.isLoading = false;
        }
    }

    fieldHasTag(member: any) {
        return !!member.tag;
    }

    async submitRequest() {
        await this.finalizeSubmission();
        // this.showTwoFactor = true;
        // await this.requestCode();
        // await this.finalizeSubmission();
        // if (this.form.has_two_factor === 1) {
        //     this.showTwoFactor = true;
        //     await this.requestCode();
        // } else {
        //     await this.finalizeSubmission();
        // }
    }

    async finalizeSubmission() {
        this.isLoading = true;
        for (const section of this.sections) {
            for (const member of section.members) {
                if (member.type.type === 'checkbox') {
                    member.value = member.options.filter(o => o.value === 1);
                }
            }
        }
        try {
            const model = {
                formUniqueId: this.uniqueId,
                parentId: this.parent.id,
                childId: this.child.id,
                notificationId: this.notificationId,
                results: JSON.stringify({
                    child_id: this.child.id,
                    child_first_name: this.child.firstName,
                    child_last_name: this.child.lastName,
                    results: this.sections
                })
            };


            if (!this.checkMandatory(this.sections)) {
                this.toastMessagesService.toastMessages('Παρακαλούμε συμπληρώστε όλα τα υποχρεωτικά πεδία που έχουν *');
                return;
            }

            // upload files if exist
            if (this.showUploadField && this.files.length > 0) {
                await this.uploadFiles();
            } else if (this.showUploadField && this.files.length === 0 && this.currentFiles.length === 0) {
                this.toastMessagesService.toastMessages('Η υποβολή της φόρμας είναι εφικτή εφόσον επισυναφθεί/ούν  το /τα σχετικό/ά έγγραφο/α.');
                return;
            }

            await this.commonService.updateItem('consents/updateCustomForm', model);
            this.toastMessagesService.toastMessages(this.submitMessage || 'Η υποβολή της δήλωσης σας ολοκληρώθηκε με επιτυχία');
            await this.notificationService.getAllNotifications(this.parent.id, true);
            if (this.isExternal) {
                await this.router.navigate(['success']);
            } else {
                await this.router.navigate(['home']);
            }
        } catch (e) {
            console.log(e);
            this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να ενημερώσουμε την δήλωσή σας. Παρακαλούμε δοκιμάστε ξανά');
        } finally {
            this.isLoading = false;
        }
    }


    checkMandatory(sections: CreatorSection[]) {
        for (const section of this.sections) {
            for (const member of section.members) {
                if (member.mandatory) {
                    if (member.type.type !== 'label' && member.type.type !== 'image' && member.type.type !== 'checkbox') {
                        if (member.value === null || member.value === false) {
                            return false;
                        }
                    }

                    if (member.type.type === 'checkbox') {
                        if (member.value.length === 0) {
                            return false;
                        }
                    }
                }
            }
        }

        return true;
    }

    async requestCode() {
        try {
            // tslint:disable-next-line:max-line-length
            const response: any = await this.commonService.updateItem(`twoStep/customForms`, {
                childId: this.child.id,
                formUniqueId: this.uniqueId,
            });
            this.toastMessagesService.toastMessages(response.object.message);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async validateCode() {
        try {
            const response = await this.submitTwoFactorCode();
            if (response && response.status === 200) {
                await this.finalizeSubmission();
            } else {
                this.toastMessagesService.toastErrorMessage('Ο κωδικός που πληκτρολογήσατε δεν είναι σωστός');
            }
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(`Ο κωδικός που πληκτρολογήσατε δεν είναι σωστός`);
        } finally {

        }
    }

    checkForReplacements(value) {
        value = value.replace('[child-name]', `${this.child.firstName} ${this.child.lastName}`);
        value = value.replace('[birthday]', `${moment(this.child.birthday).format('DD/MM/YYYY')}`);
        value = value.replace('[father-name]', `${this.child.father_first_name} ${this.child.father_last_name}`);
        value = value.replace('[mother-name]', `${this.child.mother_first_name} ${this.child.mother_last_name}`);
        value = value.replace('[parent-name]', `${this.parent.displayName}`);
        return value;
    }

    // Submitting inserted two factor code
    async submitTwoFactorCode() {
        try {
            const response: any = await this.commonService.insertItem(`twoStep/customForms/authStep`, {
                securityNumber: this.code,
                childId: this.child.id,
                formUniqueId: this.uniqueId
            });
            return response;
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    // Updating request
    async updateRequest() {
        try {
            this.isLoading = true;
            const model = {
                formUniqueId: this.uniqueId,
                childId: this.child.id,
                parentId: this.parent.id,
                uniqueToken: this.form.unique_token,
                publishedDate: this.form.published_date,
                dateCompleted: this.form.date_completed,
                results: JSON.stringify({
                    child_id: this.child.id,
                    child_first_name: this.child.firstName,
                    child_last_name: this.child.lastName,
                    results: this.sections
                })
            };
            await this.commonService.updateItem('consents/updateCustomForm/revised', model);
            this.toastMessagesService.toastMessages('Η υποβολή της δήλωσής σας ολοκληρώθηκε με επιτυχία');
            await this.notificationService.getAllNotifications(this.parent.id, true);
            // await this.router.navigate(['home']);
            this.location.back();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να ενημερώσουμε την δήλωσή σας. Παρακαλούμε δοκιμάστε ξανά');
        } finally {
            this.isLoading = false;
        }
    }

    public checkDisabled(member, option): boolean {
      if (this.form.checkbox_limit) {
        const checkedLength = member.options.filter(o => o.value).length;
        return !option.value && checkedLength >= this.form.checkbox_limit;
      }
      return false;
    }

    checkChanged(section: any, member: any, option: any) {
        if (option.value) {
            if (option.value === 1) {
                option.value = 0;
            } else {
                option.value = 1;
            }
        } else {
            option.value = 1;
        }
    }

    private getEditorMemberPredefinedValue(value) {
        try {
            value = value.replace('[parent-displayName]', `${this.parent.displayName}`);

            //#region Child Info
            value = value.replace('[child-first-name]', `${this.child.firstName}`);
            value = value.replace('[child-last-name]', `${this.child.lastName}`);
            value = value.replace('[child-displayName]', `${this.child.firstName} ${this.child.lastName}`);
            value = value.replace('[child-birthday]', `${moment(this.child.birthday).format('DD/MM/YYYY')}`);
            value = value.replace('[child-telephone]', `${this.child.phone}`);
            value = value.replace('[child-email]', `${this.child.email}`);
            //#endregion

            //#region Father Info
            value = value.replace('[father-first-name]', `${this.child.father_first_name}`);
            value = value.replace('[father-last-name]', `${this.child.father_last_name}`);
            value = value.replace('[father-displayName]', `${this.child.father_first_name} ${this.child.father_last_name}`);
            value = value.replace('[father-telephone]', `${this.child.father_telephone}`);
            value = value.replace('[father-email]', `${this.child.father_email}`);
            //#endregion

            //#region Mother Info
            value = value.replace('[mother-first-name]', `${this.child.mother_first_name}`);
            value = value.replace('[mother-last-name]', `${this.child.mother_last_name}`);
            value = value.replace('[mother-displayName]', `${this.child.mother_first_name} ${this.child.mother_last_name}`);
            value = value.replace('[mother-telephone]', `${this.child.mother_telephone}`);
            value = value.replace('[mother-email]', `${this.child.mother_email}`);
            //#endregion
        } catch (e) {
            console.log(e);
        }
        return value;
    }

    onFileInput($event: any) {
        const tempFiles = $event.target.files;
        for (const file of tempFiles) {
            file.status = false;
            file.progress = 0;
            this.files.push(file);
        }
    }

    removeFile(index: number) {
        this.files.splice(index, 1);
    }

    uploadFiles() {
        return new Promise(async (resolve, reject) => {
            for (const file of this.files) {
                try {
                    if (!file.status) {
                        await this.uploadFile(file);
                    }
                    // await this.fileService.uploadFile(`files/upload-custom-form-files`, file);
                } catch (e) {
                    this.toastMessagesService.toastErrorMessage(e);
                    reject(e);
                }
            }
            resolve(undefined);
        });
    }


    uploadFile(file) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('file', file);
            const model = {
                uniqueId: this.uniqueId,
                childId: this.child ? this.child.id : null,
            };
            file.inProgress = true;
            this.fileService.customUpload(formData, model).pipe(
                map(event => {
                    switch (event.type) {
                        case HttpEventType.UploadProgress:
                            file.progress = Math.round(event.loaded * 100 / event.total);
                            if (file.progress === 100) {
                                file.status = true;
                            }
                            break;
                        case HttpEventType.Response:
                            return event;
                    }
                }),
                catchError((error: HttpErrorResponse) => {
                    file.inProgress = false;
                    this.toastMessagesService.toastErrorMessage(`Η αποθήκυεση του ${file.name} απέτυχε`);
                    reject(error);
                    return of(`Upload failed: ${file.name}`);
                })).subscribe((event: any) => {
                if (typeof (event) === 'object') {
                    if (event.body.storagePath) {
                        this.filesPath = event.body.storagePath;
                        resolve(undefined);
                    }
                }
            });
        });
    }

    async displayAttachment(file: any) {
        try {
            const image = await this.fileService.getFile(`files/serveFile`, file.path);
            let type = '';
            if (file.originalname.toLowerCase().indexOf('.png')) {
                type = 'image/png';
            }
            if (file.originalname.toLowerCase().indexOf('.jpg')) {
                type = 'image/jpg';
            }
            if (file.originalname.toLowerCase().indexOf('.jpeg')) {
                type = 'image/jpeg';
            }
            if (file.originalname.toLowerCase().indexOf('.pdf')) {
                type = 'application/pdf';
            }

            const finalImage = await this.blobToImage(image);
            const newTab = window.open('about:blank', '_blank');
            newTab.document.write(`<object style="margin-left: auto; margin-right:auto;
  width: 50%;
  height: 100%;
  padding: 10px;" data=${finalImage} type="${type}"></object>`);
            newTab.document.close();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e);
        }
    }

    blobToImage = (blob) => {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                const base64data = reader.result;
                resolve(base64data);
            };
        });
    }

    displayButton() {
        // Αν δεν υπάρχει deadline ή δεν έχει οριστεί deadline date, δείξε το κουμπί
        if (this.form?.has_deadline !== 1 || !this.form?.deadline_date) {
            return true;
        }
        // Αν υπάρχει deadline, έλεγξε αν έχει περάσει
        const deadline = new Date(this.form.deadline_date);
        return deadline >= new Date();
    }

    editorCreated($event: any, value) {
        $event.root.innerHTML = value;
    }
}
